import {IDatasetConfig, DatasetActionOpenType, ListViewItemTypes } from 'app/interfaces';
import {fieldsMap} from './fields';
import generalForm from './forms/general.form';
import detailForm from './forms/detail.form';

const beforeCallDetail = {
	name: 'record',
	path: '/pivot/facilities/dataset/trip_package_language_contents/:parentRecordId/detail/:recordId',
};

export const PivotTripRelatedPackagesConfig: IDatasetConfig = {
	name: 'pivot_trip_related_packages',
	title: 'Pacchetti relativi',
	singleTitle: 'Pacchetto Relativo',
	ajaxDatasetCode: 'trip_packages',
	fieldsMap: fieldsMap,
	supportProperties: false,
	enabledActions: {
		detail: true,
		create: true,
		edit: false,
		list: true
	},
	formConfigsMap: {
		generalForm,
		detailForm,
	},

	pivot: {
		pivotCode: 'related',
		foreignKey: 'trip_package_id',
		parentDatasetCode: 'trip_package_language_contents'
	},
	defaultActions: {
		detail: {
			openType: DatasetActionOpenType.DIALOG,
			beforeCalls: [ beforeCallDetail ],
			viewConfig: {
				formConfig: detailForm,
				actions: {
					edit: false,
					delete: false
				}
			}
		},
		create: {
			openType: DatasetActionOpenType.DIALOG,
			viewConfig: {
				formConfig: generalForm
			}
		},
		edit: {
			openType: DatasetActionOpenType.DIALOG,
			viewConfig: {
				formConfig: generalForm
			},
		},
		list: {
			openType: DatasetActionOpenType.PAGE,
			viewConfig: {
				itemViewType: ListViewItemTypes.TABLE,
				showSearchBar: false,
				defaultSortBy: 'created_at',
				defaultSortDirection: 'desc',
				columns: [
					{
						title: 'Codice',
						key: 'package_code'
					},
					{
						title: 'Description',
						key: 'package_description'
					}
				],
				actions: ['create', 'detail', 'delete']
			}
		}
	}
};
